'use client';

import { getAuthenticatedUserData } from '@/api/amplify/helpers';
const LogRocket = require('logrocket');

const LOG_ROCKET_STUDIO_APP_ID = 'eobsz2/tolstoy-studio';

export const initLogRocket = () => {
  try {
    LogRocket.init(LOG_ROCKET_STUDIO_APP_ID);

    LogRocket.log('LogRocket Initialized');
  } catch (error) {
    console.log(error);
  }
};

export const identifyLogRocketUser = async (account) => {
  const userData = await getAuthenticatedUserData();
  const { name, email } = userData?.attributes || {};

  const { appKey, appUrl, owner } = account;

  const userInformation = {
    email,
    name,
    appKey,
    appUrl,
  };

  try {
    LogRocket.identify(owner, userInformation);
  } catch (error) {
    console.log(error);
  }
};
